import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { SummuryPipe } from '../../../Common/summury.pipe';
import { Contents } from '../../../Common/rules.module';
import { GetDataService } from '../../../services/userService/get-data.service';
import { LoaderComponent } from '../../../Common/loader/loader.component';
import { showCustomeAlert, showCustomeUpdate } from '../../../services/Alert/alert.service';
import { AuthServiceService } from '../../../services/auth-service.service';
declare function closeAllPopovers(): void;
declare function createPopovers(): void;

@Component({
  selector: 'app-admindashboard',
  imports: [CommonModule, FormsModule, RouterModule, SummuryPipe, LoaderComponent],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
  providers: [SummuryPipe]
})

export class AdminDashboardComponent implements OnInit {

  popupPosition = { top: '0px', left: '0px', right: '0px' };
  popoverBody: string = "";
  data: Contents[] = [];
  sections: Contents[] = [];
  version: number = 0;
  versions: number[] = [];
  isLoading: boolean = false;
  User: any;
  constructor(private _route: Router, private _service: GetDataService, private _summury: SummuryPipe, private _authService: AuthServiceService) { }

  ngOnInit() {
    this.isLoading = true;
    this.User = this._authService.getUserSession();
    this._service.getVersions().subscribe((res: any) => {
      this.versions = res.versions
    })
    this._service.getData().subscribe(
      (data: any) => {
        setTimeout(() => {
          this.data = data;
          this.isLoading = false;
        }, 2000);
      },
      (error: any) => {
        console.error("Error fetching rules:", error)
      }
    );
  }


  onHoverIn(event: MouseEvent, item: any) {
    this.getPopups();
    // this.item = item;
  }

  onHoverOut(event: MouseEvent) {
    // this.item = null;
  }

  onCilck(section: any) {
    this.removePopups();
    this._route.navigate([`admin/section/${section}`])
  }

  getSubRules(section: any) {
    if (section.subContents && Array.isArray(section.subContents)) {
      return section.subContents.map((rule: any) => `
      <div class="popover-rule-list">
        <div class="popover-rule-ttl">
          <a class='' href="/admin/section/${section.id}">${rule.title}</a>
          <span class='badge text-bg-primary float-end' data-toggle="tooltip" data-title="version 1.0">v${rule.version}</span>
        </div>
        <p>${this._summury.transform(rule.content, 50)}</p>
      </div>`).join("");
    }
  }

  getPopups() {
    createPopovers();
  }

  removePopups() {
    closeAllPopovers();
  }

  downloadPDF(v: any) {

    this._service.getExportedPDF(v).subscribe((res: Blob) => {
      const file = new Blob([res], { type: 'application/pdf' });
      if (file.size === 0) {
        showCustomeAlert("error", "Empty file received!", "Error");
        return;
      }
      if (file.size > 0) {
        const url = window.URL.createObjectURL(res);
        const a = document.createElement('a');
        a.href = url;
        a.download = "Rules.pdf"
        a.click();
        window.URL.revokeObjectURL(url);
      }
    }, (err) => {
      showCustomeAlert("error", "Something Worng happend..!", "Error");
    })
  }

  uploadPDF() {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = ".pdf";
    setTimeout(() => {
      fileInput.click();
    }, 200)
    fileInput.addEventListener("change", (event: Event) => {
      const input = event.target as HTMLInputElement;
      const file = input?.files?.[0];
      if (file && file?.type == 'application/pdf' && file.name.endsWith('.pdf')) {
        this.isLoading = true;
        this._service.getComparedResponse(file).subscribe(
          (res: any) => {
            this.isLoading = false;
            showCustomeAlert("success", "File Uploaded Successfully...!!", "File Uploaded.");
            let cleanedResponse = res.response
              .replace(/```json\s*/g, '')
              .replace(/```/g, '')
              .trim();
            cleanedResponse = cleanedResponse.replace(/[\u0000-\u001F\u007F]/g, (char: any) => {
              if (char === '\n' || char === '\t') return char; // Keep newline & tab
              return ''; // Remove others
            });
            try {
              const parsedResponse = JSON.parse(cleanedResponse);
              const formatted = this.formatResponse(parsedResponse);
              const changesHtml =
                `<div class='row row-cols-1 row-cols-md-2 row-cols-lg-3 overflow-y-auto' style="height: 300px;">` +
                formatted.changes.map((change: any, index: number) => `
              <div style="text-align: left; margin-bottom: 15px; border:1px solid black;" class='col'>
                <strong>Change : </strong> ${index + 1} <br/>
                <strong>Change ID : </strong> ${change.id} <br/>
                <b>Original Title:</b> ${change["original-Title"]}<br/>
                <b>Changed Title:</b> ${change["changed-Title"]}<br/>
                <b>Note:</b> ${change["abandon-note"]}<br/>
                <b>Original Content:</b><br/><p  style="background:#f5f5f5;padding:8px;">${change["original-content"]}</p>
                <b>Changed Content:</b><br/><p  style="background:#f5f5f5;padding:8px;">${change["changed-content"]}</p>
              </div>
              `).join('') +
                `</div>
             <hr/>
                  <div class="text-sm" style="text-align: justify;">
                    <strong>Summary : </strong>
                      ${formatted.summary}
                  </div>
                  <div style="color: #000; margin-top: 8px;"><strong>Total:</strong> ${formatted.counts.total_changes}</div>
                  <div style="display: flex; gap: 30px; margin-top: 8px;">
                    <div style="color: green;"><strong>Insertions:</strong> ${formatted.counts.Insertion}</div>
                    <div style="color: orange;"><strong>Modifications:</strong> ${formatted.counts.Modification}</div>
                    <div style="color: red;"><strong>Deletions:</strong> ${formatted.counts.Deletion}</div>
                  </div>
                `;
              showCustomeUpdate("info", changesHtml, "Are you sure,You want to apply changes ?", () => {
                this.structuredResponseToContent(formatted, file)
              });
            } catch (err) {
              showCustomeAlert("error","Error occured while parsing the response..","Parsing Error");
            }
          },
          (err) => {
            showCustomeAlert("error", "Something wrong happed while uploading the file.", "Error")
          })
      }else{
        showCustomeAlert("warning","Please Upload PDF files only","Invalid File Type")
      }
    })
  }
  formatResponse(response: any) {
    const formattedChanges = response.changes.map((change: any) => {
      return {
        'id': change.ID,
        'original-Title': change['original-Title'],
        'changed-Title': change['changed-Title'],
        'original-content': change['original-content'].trim(),
        'changed-content': change['changed-content'].trim(),
        'abandon-note': change['abandon-note'],
        'change-type': change['change-type']
      };
    });
    const result = {
      changes: formattedChanges,
      summary: response.summary,
      counts: response.counts
    };
    return result;
  }

  structuredResponseToContent(formatted: any, file: File) {
    this.isLoading = true;
    const contents: any[] = []
    formatted.changes.forEach((change: any) => {
      const oldContent = this._service.getDataById(change.id).subscribe((res: any) => {
        this.isLoading = false;
        const data = res.find((r: any) => r.id == change.id)
        if (data) {
          const content = {
            id: change.id,
            content: change['changed-content'],
            title: change['changed-Title'],
            abandonedNote: change['abandon-note'],
            parentContentID: data.parentContentID,
            version: incrementVersion(data.version),
            contentTypeID: 1,
            displayOrder: 1,
          }
          contents.push(content);
          this._service.addData({ node: content, version: content.version }, this.User.userName, content.id).subscribe((res: any) => {
            // showCustomeAlert("success","Your  Update has been saved..!","Updated Successfully.!")
          });
        }
        this.isLoading = false;
      })
    });
    this._service.uploadPDF(file).subscribe((res: any) => {
      if (res) {
        showCustomeAlert("success", res.message, "Upload Done")
      }
    })
  }
}

export function incrementVersion(version: string) {
console.log(version);

const parts = version.split('.').map(Number);

  if (parts.length === 2) {
   parts[1] += 1;
    return `${parts[0]}.${parts[1]}`;
  } else if (parts.length === 3) {
    if (parts[2] >= 10) {
      parts[1] += 1;
      parts[2] = 0;
      return `${parts[0]}.${parts[1]}`;
    } else {
      parts[2] += 1;
      return `${parts[0]}.${parts[1]}.${parts[2]}`;
    }
  } else {
    throw new Error("Unsupported version format");
  }
}
